import CourseFilterDropdown from "./CourseFilterDropdown";
import { Input, Select, DatePicker, TimePicker, Radio } from "antd";
import dayjs from "dayjs";

const { Option } = Select;

const EventFormBlock = ({ event, index, onChange, onRemove }) => {

    // Handle mandatory change - automatically set access_type to "Open"
  const handleMandatoryChange = (val) => {
    onChange(event.id, "mandatory", val);
    if (val === "Yes") {
      onChange(event.id, "access_type", "Open");
      onChange(event.id, "min_participants", null);
      onChange(event.id, "max_participants", null);
    }
  };

  return (
    <div
      key={event.id}
      className="event-block"
      style={{ position: "relative" }}
    >
      {/* Close (X) icon in top-right */}
      <span
        onClick={() => onRemove(event.id)}
        style={{
          position: "absolute",
          top: "8px",
          right: "10px",
          cursor: "pointer",
          color: "#ff0000ff",
          fontSize: "18px",
        }}
      >
        ✖
      </span>

      <h4 className="event-block-title">
        Event {index + 1}
        {event.type && (
          <span
            style={{
              color: "#1677ff",
              marginLeft: "8px",
              fontSize: "14px",
            }}
          >
            (
            {event.type === "ilt"
              ? " ILT "
              : event.type === "virtual"
              ? " Virtual "
              : " E-learning "}
            )
          </span>
        )}
      </h4>

      {!event.type ? (
        <>
          <label className="form-label-first">Event Mode</label>
          <Radio.Group
            onChange={(e) => onChange(event.id, "type", e.target.value)}
          >
            <Radio value="virtual">Virtual</Radio>
            <Radio value="ilt">ILT</Radio>
            <Radio value="e-learning">E-learning</Radio>
          </Radio.Group>
        </>
      ) : (
        <>
          <label className="form-label-first">Mandatory</label>
          <Select
            placeholder="Is this event mandatory?"
            className="form-select full-width"
            onChange={handleMandatoryChange}
            value={event.mandatory || undefined}
          >
            <Option value="Yes">Yes</Option>
            <Option value="No">No</Option>
          </Select>

          <label className="form-label">Topic</label>
          <Input
            placeholder="Enter topic"
            value={event.topic}
            onChange={(e) => onChange(event.id, "topic", e.target.value)}
            className="form-input"
          />

          <label className="form-label">Trainer</label>
          <Input
            placeholder="Enter trainer name"
            value={event.trainer}
            onChange={(e) => onChange(event.id, "trainer", e.target.value)}
            className="form-input"
          />

          <label className="form-label">Start Date</label>
          <DatePicker
            className="form-input full-width"
            onChange={(_, dateStr) => onChange(event.id, "start_date", dateStr)}
            disabledDate={(current) =>
              current && current < dayjs().startOf("day")
            }
          />

          <label className="form-label">End Date</label>
          <DatePicker
            className="form-input full-width"
            onChange={(_, dateStr) => onChange(event.id, "end_date", dateStr)}
            disabledDate={(current) =>
              current && current < dayjs().startOf("day")
            }
          />

          <label className="form-label">Start & End Timing</label>
          <TimePicker.RangePicker
            use12Hours
            format="hh:mm A"
            className="form-input full-width"
            onChange={(value) => onChange(event.id, "timing", value)}
          />

          {event.type === "virtual" ? (
            <>
              <label className="form-label">Link</label>
              <Input
                placeholder="Enter online event link"
                value={event.link}
                onChange={(e) => onChange(event.id, "link", e.target.value)}
                className="form-input"
              />
            </>
          ) : event.type === "ilt" ? (
            <>
              <label className="form-label">Location</label>
              <Select
                placeholder="Select location"
                className="form-select full-width"
                onChange={(val) => onChange(event.id, "location", val)}
                value={event.location || undefined}
              >
                <Option value="Training Room 1">Training Room 1</Option>
                <Option value="Training Room 2">Training Room 2</Option>
                <Option value="Training Room 3">Training Room 3</Option>
              </Select>
            </>
          ) : event.type === "e-learning" ? (
            <>
              <label className="form-label">Select Course</label>
              <CourseFilterDropdown
                value={event.courseData}
                onChange={(courseData) =>
                  onChange(event.id, "courseData", courseData)
                }
                placeholder="Choose a course"
              />
            </>
          ) : null}

          <label className="form-label">Event Type</label>
          <Select
            value={event.mandatory === "Yes" ? "Open" : event.access_type}
            className="form-select full-width"
            disabled={event.mandatory === "Yes"}
            onChange={(val) => onChange(event.id, "access_type", val)}
          >
            <Option value="Open">Open</Option>

            {event.mandatory !== "Yes" && (
              <Option value="Limited">Limited</Option>
            )}
          </Select>

          {/* Min/Max Block */}
          {event.mandatory !== "Yes" && event.access_type === "Limited" && (
            <div>
              <label className="form-label">Min Participants</label>
              <Input
                value={event.min_participants}
                onChange={(e) =>
                  onChange(event.id, "min_participants", e.target.value)
                }
                type="number"
                className="form-input"
              />

              <label className="form-label">Max Participants</label>
              <Input
                value={event.max_participants}
                onChange={(e) =>
                  onChange(event.id, "max_participants", e.target.value)
                }
                type="number"
                className="form-input"
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default EventFormBlock;
